import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    
  palette: {
    primary: {
      main: '#82C8E5', 
    },
  },
  typography: {
    fontFamily: 'Roboto, sans-serif',
  },
});


export default theme;
